import { Client } from "./client";
import { PROCEDURETYPE } from "@/backend/models/procedureInstances/procedureInstanceBase";
import { ExportJsonResponse, ProcedureInstanceCreateFromTemplateReply, ProcedureInstanceCreateRequest, ProcedureInstanceReadAllResponse, ProcedureInstanceResponse, ProcedureInstanceUpdateRequest } from "@/backend/express/controllers/procedureInstanceController";
import { FusaReply } from "@/types/replyTypes";

export class ProcedureInstanceController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readAllByType(procedureType: PROCEDURETYPE): Promise<ProcedureInstanceReadAllResponse> {
    return this.client.read(`/api/procedure-instances/all/${procedureType}`);
  }

  delete(procedureInstanceId: string): Promise<FusaReply> {
    return this.client.delete(`/api/procedure-instances/${procedureInstanceId}`);
  }

  duplicate(procedureInstanceId: string): Promise<ProcedureInstanceResponse> {
    return this.client.create(`/api/procedure-instances/duplicate/${procedureInstanceId}`, {});
  }

  create(request: ProcedureInstanceCreateRequest): Promise<ProcedureInstanceResponse> {
    return this.client.create(`/api/procedure-instances`, request);
  }

  update(request: ProcedureInstanceUpdateRequest): Promise<ProcedureInstanceResponse> {
    return this.client.update(`/api/procedure-instances`, request);
  }

  view(procedureInstanceId: string): Promise<ProcedureInstanceResponse> {
    return this.client.update(`/api/procedure-instances/markViewed/${procedureInstanceId}`, {});
  }

  read(procedureInstanceId: string): Promise<ProcedureInstanceResponse> {
    return this.client.read(`/api/procedure-instances/${procedureInstanceId}`);
  }

  initializeFromTemplate(templateId: string, projectId?: string): Promise<ProcedureInstanceResponse> {
    return this.client.create(`/api/procedure-instances/initializeFromTemplate/${templateId}`, { projectId });
  }

  createProcedureFromTemplate(id: string, functionalInterfaceImplementationAssignments?: { [key: string]: string }): Promise<ProcedureInstanceCreateFromTemplateReply> {
    return this.client.create(`/api/procedure-instances/createFromTemplate/${id}`, { functionalInterfaceImplementationAssignments });
  }

  readPublishedTemplatesForEnterprise(): Promise<ProcedureInstanceReadAllResponse> {
    return this.client.read(`/api/procedure-instances/published-templates-for-enterprise`);
  }

  readAllGeneratedProceduresForProject(projectId: string): Promise<ProcedureInstanceReadAllResponse> {
    return this.client.read(`/api/procedure-instances/generatedProceduresForProject/${projectId}`);
  }

  readAllAssignedToProject(projectId: string): Promise<ProcedureInstanceReadAllResponse> {
    return this.client.read(`/api/procedure-instances/assignedToProject/${projectId}`);
  }

  exportJson(procedureInstanceId: string): Promise<ExportJsonResponse> {
    return this.client.read(`/api/procedure-instances/exportJson/${procedureInstanceId}`);
  }
}
